import { formatMoneyString } from "src/utility/utilityFunctions";

export const CompareCosts = ({
  cost,
  comparedTo,
}: {
  cost: number | string | undefined;
  comparedTo: number | string | undefined;
}) => {
  const fCost = formatMoneyString(cost);
  const fCompCost = formatMoneyString(comparedTo);
  if (fCost !== fCompCost) {
    return (
      <span>
        <span className="line-through opacity-50">&nbsp;{fCompCost}&nbsp;</span>
        <span className="pl-0.5">{fCost}</span>
      </span>
    );
  }
  return <span>{formatMoneyString(cost)}</span>;
};

export default CompareCosts;
